import "./Filter.css";

const RATING_OPTIONS = [
  { label: "All ratings", value: 0 },
  { label: "6+ ★", value: 6 },
  { label: "7+ ★", value: 7 },
  { label: "8+ ★", value: 8 },
  { label: "9+ ★", value: 9 },
];

export default function Filter({
  title,
  rating,
  onTitleChange,
  onRatingChange,
}) {
  const hasFilters = title !== "" || rating !== 0;

  return (
    <div className="filter">
      {/* Search */}
      <div className="filter__field">
        <span className="filter__icon">⌕</span>
        <input
          className="filter__input"
          type="text"
          placeholder="Search by title…"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
        />
        {title && (
          <button className="filter__clear" onClick={() => onTitleChange("")}>
            ✕
          </button>
        )}
      </div>

      {/* Rating pills */}
      <div className="filter__pills">
        {RATING_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            className={`pill ${rating === opt.value ? "pill--active" : ""}`}
            onClick={() => onRatingChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* Clear all */}
      {hasFilters && (
        <button
          className="filter__reset"
          onClick={() => {
            onTitleChange("");
            onRatingChange(0);
          }}
        >
          Clear filters
        </button>
      )}
    </div>
  );
}
